import backgroundDesktop from "../../img/assets/background-desktop.jpg";
import backgroundMobile from "../../img/assets/background-mobile.jpg";
import questionCard from "../../img/assets/question-card2.png";
import questionBorder from "../../img/assets/question-border.png";
import leaderboardText from "../../img/assets/leaderboard-text.png";
import howToPlayBackground from "../../img/assets/how-to-play-background.png";

/** Raster-only feud shell assets. Logo from theme (S3); result modal and avatars are CSS-only. */
export const officeFunFeudAssets = {
  backgroundDesktop,
  backgroundMobile,
  questionCard,
  questionBorder,
  leaderboardText,
  howToPlayBackground,
};
